module.exports = __webpack_public_path__ + "static/score-details-b4a891d21d612d32866d5e1b1ce64ed4.mp4";